import { gql } from '@apollo/client';

const PRINT_SUPPLIER_ORDERS = gql`
  query PrintSupplierOrders(
    $supplierCompanyId: Int!
    $supplierOrderIds: [Int!]
  ) {
    incomingOrdersContext {
      printSupplierOrders(
        supplierCompanyId: $supplierCompanyId
        supplierOrderIds: $supplierOrderIds
      )
    }
  }
`;

export default PRINT_SUPPLIER_ORDERS;
